const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3333'

export function getAvatarUrl(
  avatarUrl: string | null | undefined
): string | undefined {
  if (!avatarUrl) return undefined

  // Use proxy endpoint for S3/Linode images to avoid CORS issues
  if (avatarUrl.includes('linodeobjects.com')) {
    // Encode the URL to pass it as a query parameter
    const encodedUrl = encodeURIComponent(avatarUrl)
    return `${API_BASE_URL}/api/images/proxy?url=${encodedUrl}`
  }

  return avatarUrl
}
